// @flow
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';

import { getJobStatusFlags } from 'src/modules/job-status';
import { CardGroup, ScreenReaderOnly, Card } from 'seek-style-guide/react';

import styles from './JobApply.less';

import ApplyButtonCard from './ApplyButtonCard/ApplyButtonCard';
import ExpiredMessage from './ExpiredMessage/ExpiredMessage';
import JobActionsCard from './JobActionsCard/JobActionsCard';

type Props = {|
  job: ChaliceJobDetail,
  appliedDateUTC?: string,
  isApplied: boolean,
  isSaved: boolean
|};

class JobApply extends PureComponent<Props> {
  render() {
    const { job, appliedDateUTC, isApplied, isSaved } = this.props;
    const {
      isLinkOut,
      id: jobId,
      isScreenAssigned,
      isSelectionCriteriaEnabled,
      isExpired,
      expiryDate
    } = job;

    return (
      <Card>
        <section aria-labelledby="jobApplyHeader">
          <ScreenReaderOnly>
            <h1 id="jobApplyHeader">Job Apply</h1>
          </ScreenReaderOnly>
          {isExpired ? (
            <ExpiredMessage expiryDate={expiryDate} />
          ) : (
            <CardGroup className={styles.cardGroup}>
              <ApplyButtonCard
                {...{
                  isLinkOut,
                  jobId,
                  appliedDateUTC,
                  isScreenAssigned,
                  isSelectionCriteriaEnabled,
                  isExpired,
                  isApplied
                }}
              />
              <JobActionsCard {...{ job, isApplied, isSaved }} />
            </CardGroup>
          )}
        </section>
      </Card>
    );
  }
}

const mapStateToProps = ({ savedJobs, jobdetails }): Props => {
  const { result: job, jobApplication } = jobdetails;
  const { isApplied, isSaved } = getJobStatusFlags({
    savedJobs: savedJobs.jobs,
    jobId: get(job, 'id')
  });
  const appliedDateUTC = get(jobApplication, 'appliedDateUTC');

  return {
    job,
    appliedDateUTC,
    isApplied,
    isSaved
  };
};

export { JobApply as JobApplyForTest };
export default connect(mapStateToProps)(JobApply);
